var E = /* @__PURE__ */ ((_) => (_.ADMIN_TOKEN = "admin_token", _.ADMIN_TOKEN_EXPIRE_TIME = "admin_token_expire_time", _.ADMIN_REFRESH_TOKEN = "admin_refresh_token", _.ADMIN_REMEMBER_ME = "admin_remember_me", _))(E || {});
export {
  E as StorageKeyEnum
};
